import React, { FC } from 'react';
import IFrameworkFilter from './IFrameworkFilter';
import { ISelectOption } from '../../../../utils/types';
import MultiSelectFilter from '../multi-select-filter/MultiSelectFilter';

const FrameworkFilter: FC<IFrameworkFilter> = ({ options, placeholder, setFilters }) => {
	const filterKey = 'frameworkFilter';
	const propertyName = 'framework';

	const onMultiSelectValueChange = (value: ISelectOption[]) => {
		if (!value.length) {
			setFilters((prev: any) => ({
				...prev,
				[filterKey]: (dataRecord: any) => true,
			}));
			return;
		}

		setFilters((prev: any) => ({
			...prev,
			[filterKey]: (dataRecord: any) =>
				value.some((v) => {
					return v.value === dataRecord[propertyName].id;
				}),
		}));
	};

	return (
		<MultiSelectFilter
			placeholder={placeholder || 'Framework'}
			options={options || []}
			onChange={onMultiSelectValueChange}
			isTagStyledList={false}
		/>
	);
};

export default FrameworkFilter;
